/* @generated */
import cx from "classnames";
import { normalizeResponsiveValue } from "./atoms.css.esm.js";
const ensureFullyPackedResponsiveArray = (value) => {
  var _a, _b, _c, _d;
  let lastValue;
  const values = value.map((v) => {
    if (v !== lastValue && v !== null) {
      lastValue = v;
      return v;
    }
    return null;
  });
  return [(_a = values[0]) != null ? _a : null, (_b = values[1]) != null ? _b : null, (_c = values[2]) != null ? _c : null, (_d = values[3]) != null ? _d : null];
};
const resolveResponsivePropToClassName = (value, xsmallAtoms, smallAtoms, mediumAtoms, largeAtoms, xLargeAtoms) => {
  var _a, _b, _c, _d, _e;
  if (typeof value === "string" || typeof value === "number") {
    return xsmallAtoms[value];
  }
  const normalized = normalizeResponsiveValue(value);
  const [xsmall, small, medium, large, xlarge] = ensureFullyPackedResponsiveArray([
    (_a = normalized.xsmall) != null ? _a : null,
    (_b = normalized.small) != null ? _b : null,
    (_c = normalized.medium) != null ? _c : null,
    (_d = normalized.large) != null ? _d : null,
    (_e = normalized.xlarge) != null ? _e : null
  ]);
  const xsmallAtom = xsmallAtoms[xsmall];
  const smallAtom = smallAtoms[small];
  const mediumAtom = mediumAtoms[medium];
  const largeAtom = largeAtoms[large];
  const xlargeAtom = xLargeAtoms[xlarge];
  return cx(xsmallAtom, smallAtom, mediumAtom, largeAtom, xlargeAtom);
};
export {
  resolveResponsivePropToClassName
};
